import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Services from "@/pages/Services";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Reminders from "@/pages/Reminders";
import Chasers from "@/pages/Chasers";
import EmailTemplates from "@/pages/EmailTemplates";
import EmailLogs from "@/pages/EmailLogs";
import Reports from "@/pages/Reports";
import SettingsPage from "@/pages/Settings";
import Vault from "@/pages/Vault";
import Invoices from "@/pages/Invoices";
import ClientPortal from "@/pages/ClientPortal";
import UsersPage from "@/pages/Users";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback synchronously (before ProtectedRoute logic)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/portal/:token" element={<ClientPortal />} />
      <Route element={<Layout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:clientId" element={<ClientDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/:jobId" element={<JobDetail />} />
        <Route path="/reminders" element={<Reminders />} />
        <Route path="/chasers" element={<Chasers />} />
        <Route path="/email-templates" element={<EmailTemplates />} />
        <Route path="/email-logs" element={<EmailLogs />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/vault" element={<Vault />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
